import { AfterViewInit, Component, ElementRef, input, output, viewChild } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import type { EkpiPerformanceModelType } from "../../../models";

export const ekpiValue = (ekpi: EkpiPerformanceModelType) => {
  if (ekpi.actual === null || ekpi.actual === undefined) return "-";
  if (ekpi.measurementUnit === Constants.MEASUREMENT.PERCENTAGE) {
    return AdaaHelper.percentageValue(ekpi.actual);
  }
  return AdaaHelper.roundValue(ekpi.actual);
};

@Component({
  selector: "adaa-pillar-ekpi-info",

  imports: [TranslateTokenPipe, TranslatePipe],
  styleUrl: "./government-enabler-pillars.scss",
  template: `
    <div #kpiList class="pillar-ekpis">
      @if (ekpiList().length) {
        <span class="pillar-ekpis__caption">{{ "graphic.kpi.actual" | translate }}</span>
      }
      @for (item of ekpiList(); track item.id) {
        <div
          class="pillar-ekpis__row"
          [class.pillar-ekpis__row--active]="item.id === activeEkpiId()"
          (mouseenter)="ekpiHovered.emit(item.id)"
          (mouseleave)="ekpiHovered.emit(null)"
          (click)="ekpiClicked.emit(item.id)"
        >
          <span class="pillar-ekpis__dot" [style.background-color]="getColor(item.evaluation)"></span>
          <span class="pillar-ekpis__value" [style.color]="getColor(item.evaluation)">
            {{ getValue(item) }}
          </span>
          <span class="pillar-ekpis__name">{{ item | translateToken: "ekpiName" }}</span>
        </div>
      } @empty {
        <span class="pillar-ekpis__empty">{{ "nkpi.no_data_recorded" | translate }}</span>
      }
    </div>
  `,
})
export class EkpiInfoComponent implements AfterViewInit {
  ekpiList = input.required<EkpiPerformanceModelType[]>();
  activeEkpiId = input<number | null>(null);

  kpiListContent = output<string>();
  ekpiHovered = output<number | null>();
  ekpiClicked = output<number>();

  kpiList = viewChild<ElementRef>("kpiList");

  public ngAfterViewInit() {
    const content = this.kpiList()?.nativeElement.innerHTML;
    this.kpiListContent.emit(content);
  }

  public getColor(code?: number) {
    return Constants.COLOR_CODES[code ?? Constants.CONSTANT_COLORS.EVALUATION_GRAY];
  }

  public increaseWidth(value?: number) {
    return !(value === null || value === undefined);
  }

  public getValue(ekpi: EkpiPerformanceModelType) {
    return ekpiValue(ekpi);
  }
}
